import React from 'react';
import { useTabMain } from '@hooks/paramsHooks';
import { CompareLayer } from '@modules/compare/CompareLayer';
import TagLineTip from '../../tagLine/TagLineTip';
import {
  GroupViewCaptureWidget,
  HotspotGroupWidget,
  HotspotWidgets,
  PolygonTip,
} from '../../hotspot';
import BasicWidgets from './BasicWidgets';
import { ViewCaptureWidget } from '../../view';
import { SceneSandTable } from './SceneSandTable';
import { SunlightTip } from '../../effect/SunlightTip';
import { VHumanWidget } from '../../autoRotate/VHumanWidget';
import { SubtitlePreview } from '../../subtitle/SubtitlePreview';
import { RotateSubtitle } from '../../autoRotate/RotateSubtitle';
import { RotateTip } from '../../autoRotate/RotateTip';
import { SceneComponentLayers } from '../../componentLayer/SceneComponentLayers';
import NorthViewCaptureWidget from '../../compass/NorthVIewCaptureWidget/NorthViewCaptureWidget';

function SceneWidgets() {
  const tab = useTabMain();
  return (
    <>
      {tab === 'basic' && <BasicWidgets />}
      {tab === 'view' && <ViewCaptureWidget />}
      {tab === 'hotspot' && <HotspotWidgets />}
      {tab === 'hotspot' && <PolygonTip />}
      {tab === 'hotspot' && <GroupViewCaptureWidget />}
      {tab === 'hotspot' && <HotspotGroupWidget />}
      {tab === 'sandTable' && <SceneSandTable />}
      {tab === 'effect' && <SunlightTip />}
      {tab === 'rotate' && <VHumanWidget />}
      {tab === 'rotate' && <RotateSubtitle />}
      {tab === 'rotate' && <RotateTip />}
      {tab === 'subtitle' && <SubtitlePreview />}
      {tab === 'tagLine' && <TagLineTip />}
      {tab === 'compass' && <NorthViewCaptureWidget />}
      {tab === 'component' && <SceneComponentLayers />}
      {tab === 'compare' && <CompareLayer />}
    </>
  );
}

export default SceneWidgets;
